import { useFormContext } from 'react-hook-form'
import { formSchema } from './sections/RecruitmentSection'
import { z } from 'zod'
import { legacyBackgroundStyle } from '../../TeamApplicants/utils'
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useTeam } from 'app/frontend/base/config/context/team'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const LegacyApplicationFormPreview = () => {
  const { guild } = useTeam()
  const form = useFormContext<z.infer<typeof formSchema>>()
  const recruitmentDetails = form.watch('recruitmentDetails')

  return (
    <div
      className='rounded-sm border flex-1 w-full flex justify-center items-center py-8 px-16'
      style={{
        ...legacyBackgroundStyle(recruitmentDetails.css_background),
        color: recruitmentDetails.css_text,
      }}
    >
      <div
        className='h-full w-full rounded-md flex flex-col gap-2 max-w-md'
        style={legacyBackgroundStyle(recruitmentDetails.css_body)}
      >
        <div className='flex justify-center mt-4 mb-2'>
          {recruitmentDetails.logo ? (
            <img src={recruitmentDetails.logo} className='h-8' />
          ) : (
            <span
              className='text-lg font-bold'
              style={{ color: recruitmentDetails.css_headers }}
            >
              {guild.name}
            </span>
          )}
        </div>

        <div
          className='h-6 w-full text-accent-foreground text-[7px] flex items-center justify-between px-4'
          style={{ background: recruitmentDetails.css_header_bar }}
        >
          <span className='flex items-center gap-1'>
            <ChevronLeft size={9} /> Back to website
          </span>

          <span className='flex items-center gap-1'>
            User#1234 <ChevronDown size={6} />
          </span>
        </div>

        <div className='px-4 flex flex-col gap-2 mb-6'>
          <div
            className='text-[12px]'
            style={{ color: recruitmentDetails.css_headers }}
          >
            Apply to {guild.name}
          </div>

          <div className='text-[7px] leading-normal'>
            {recruitmentDetails.introduction}
          </div>

          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index}>
              <Label className='text-[7px]'>Question {index + 1}</Label>
              <Input
                type='text'
                className='border-none text-[7px] h-5'
                style={{ background: recruitmentDetails.css_inputs }}
                placeholder='Your answer'
                tabIndex={-1}
              />
            </div>
          ))}

          <div className='flex justify-end mt-2'>
            <Button
              size='xs'
              type='button'
              className='text-[7px] text-accent-foreground pointer-events-none'
              style={{ background: recruitmentDetails.css_header_bar }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LegacyApplicationFormPreview
